export default "__VITE_ASSET__06eaed6a__"